var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMgpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2f2e8bdd-21cc-46f2-87a6-7eb3b3b63409",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-aa941bfa-dc95-4386-80e5-47f2181fc794{fill:#c4d4a0;}.uuid-83ce10c1-5e9d-4114-94db-022e49c29533{fill:#f5eee4;}.uuid-50bb84fd-a51d-4699-b83e-91c26d528262{fill:#7ea52e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-83ce10c1-5e9d-4114-94db-022e49c29533",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-50bb84fd-a51d-4699-b83e-91c26d528262",
    d: "m161.74,100.3s-37.33,203.4,76.95,144.06l-76.93-144.07h-.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-aa941bfa-dc95-4386-80e5-47f2181fc794",
    d: "m161.74,100.3s191.18,84.75,76.9,144.07l-76.9-144.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-50bb84fd-a51d-4699-b83e-91c26d528262",
    d: "m439.21,272.12s-150.91-147.96-171.64-24.25l171.64,24.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-aa941bfa-dc95-4386-80e5-47f2181fc794",
    d: "m439.21,272.16s-192.06,99.47-171.64-24.25l171.64,24.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-50bb84fd-a51d-4699-b83e-91c26d528262",
    d: "m155.6,411.77s190.39-91.93,71.22-144.87l-71.22,144.87h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-aa941bfa-dc95-4386-80e5-47f2181fc794",
    d: "m155.6,411.77s-47.93-197.96,71.22-144.86l-71.22,144.86Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMgpi);
export default __webpack_public_path__ + "static/media/icon_mgpi.8e959c83838804ca614dbb75db9060b5.svg";
export { ForwardRef as ReactComponent };